import { Power1, TweenMax } from 'gsap';
import { GameAudio } from '../../../Config/Audio';
import SoundManager from '../../../Sound/SoundManager';
import { IRewardItem } from '../../../State/reducers/score';
import { waitForMs } from '../../../Utils/AsyncUtils';
import { RewardSparkle } from '../../Animations/RewardSparkle';
import getLogger from '../../../Core/Logger';
import { RewardGroup } from '../Win/RewardGroup';
import { HudActions } from '../../../Managers/Hud/HudEmitter';

const logger = getLogger('[GIFTREWARDBOX]:');

export class SocialRewardBox extends PIXI.Sprite {
    private box: PIXI.Sprite;
    private boxContents: IRewardItem[];
    private type: string;

    constructor(contents: IRewardItem[], type: string) {
        super();

        this.boxContents = contents;
        this.type = type;

        if (type === 'social') {
            this.box = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/giftBoxSocialhub_closed']);
        } else {
            this.box = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/giftbox-closed']);
        }

        this.box.anchor.set(0.5, 1);
        this.box.y = this.box.height * 0.7;

        this.addChild(this.box);
    }

    /**
     * opens the reward box
     */
    public async openBox() {
        let openTexture: PIXI.Texture;

        if (this.type === 'social') {
            openTexture = PIXI.utils.TextureCache['mapui/giftBoxSocialhub_open'];
        } else {
            openTexture = PIXI.utils.TextureCache['commonui/giftbox-open'];
        }

        SoundManager.playSound(GameAudio.REWARD_OPEN);
        TweenMax.to(this.box.scale, 0.3, {
            y: 0.9,
            repeat: 1,
            yoyo: true,
            onComplete: () => {
                this.box.texture = openTexture;
                const r = new RewardSparkle(2);
                r.anchor.set(0.5);
                this.addChild(r);
                r.play();
                const contents = this.showContents();
                contents.catch(err => {
                    logger.debug('error showing reward box contents: ' + err);
                });

                TweenMax.to(this.box.scale, 0.3, {
                    y: 1.2,
                    repeat: 1,
                    yoyo: true,
                    onComplete: () => {},
                });
            },
        });

        this.emit(HudActions.OPEN_REWARD_BOX, this.boxContents);
        await waitForMs(2000);
    }

    /**
     * shows the content in the rewar box
     */
    private async showContents() {
        TweenMax.killTweensOf(this.box);
        this.box.rotation = 0;
        const groups: RewardGroup[] = [];
        this.boxContents.forEach((reward, index) => {
            const r = new RewardGroup(reward.id, reward.val);
            r.x = this.box.x;
            r.y = this.box.y - this.box.height;
            r.scale.set(0);
            this.addChild(r);
            TweenMax.to(r.scale, 0.5, { x: 0.8, y: 0.8, delay: 0.5 * index });

            // added bezier function
            TweenMax.to(r, 0.7, {
                bezier: {
                    type: 'soft',
                    values: [{ x: r.x, y: r.y }, { x: r.x, y: 0 }, { x: r.x, y: this.box.height }],
                },
                delay: 0.5 * index,
                ease: Power1.easeIn,
            });
            groups.push(r);
        });
        return;
    }
}
